import dataProvider from 'service/data_provider'
import Controller from 'lib/controller'
import Model from 'model/model'
import Router from 'service/router'
import upgradeService from 'service/upgrade'
import PaginatorCollection from 'component/paginator/collection/paginator'
import CallToActionView from 'component/cta/become_consul/become_consul'
import ConnectButtonView from 'component/connect_button/connect_button'
import PaywallView from 'component/paywall/paywall'
import ActivityListView from 'bundle/activity_group/view/activities'
import GroupHeaderView from 'bundle/activity_group/view/group_header'
import loadMoreTemplate from 'component/paginator/template/_loadMoreWhiteBoxWithSections.tmpl'
import CollapsibleTextView from 'view/collapsible_text'

const PageState = Model.extend({
    parseEmbedded(embedded) {
        return {
            past: new PaginatorCollection(embedded.past, { parse: true }),
            upcoming: new PaginatorCollection(embedded.upcoming, { parse: true }),
        }
    },
})

const Ctrl = Controller.extend({
    initialize() {
        this.pageState = new PageState(dataProvider.get('activities'), { parse: true, isHal: true })

        this._initGroupHeader()
        this._initSidebar()
        this._initUpcomingActivities()
        this._initPastActivities()

        if (dataProvider.get('showMembershipRequiredModal')) {
            this._showMembershipRequiredPaywall()
        }

        this.$('.js-collapsible-text').each((index, element) => {
            this.initSubview(CollapsibleTextView, { el: element })
        })
    },

    _initGroupHeader() {
        this.initSubview(GroupHeaderView, {
            el: this.$('.js-group-header'),
        }).render()
    },

    _initSidebar() {
        if (this.$('.js-become-consul-cta').length) {
            this.initSubview(CallToActionView, {
                el: this.$('.js-become-consul-cta'),
                activityGroupId: dataProvider.get('activityGroup').id,
                hasActiveConsuls: dataProvider.get('hasActiveConsuls'),
            }).render()
        }

        this.$('.js-connect-button').each((index, element) => {
            this.initSubview(ConnectButtonView, { el: element })
        })
    },

    _initUpcomingActivities() {
        const upcomingActivitiesView = this.initSubview(ActivityListView, {
            collection: this.pageState.getEmbedded('upcoming'),
            mode: 'manual',
            activityGroupId: dataProvider.get('activityGroup').id,
            isMember: dataProvider.get('isMember'),
            isPaginationEnabled: Boolean(dataProvider.get('currentUser')),
            templates: {
                loadMore: loadMoreTemplate,
            },
        })

        upcomingActivitiesView.render()

        this.$('.js-upcoming-activities-container').html(upcomingActivitiesView.el)
    },

    _initPastActivities() {
        const pastActivitiesView = this.initSubview(ActivityListView, {
            collection: this.pageState.getEmbedded('past'),
            mode: 'manual',
            isPaginationEnabled: Boolean(dataProvider.get('currentUser')),
            templates: {
                loadMore: loadMoreTemplate,
            },
        })

        pastActivitiesView.render()

        this.$('.js-past-activities-container').html(pastActivitiesView.el)
    },

    _showMembershipRequiredPaywall() {
        const activityGroupId = dataProvider.get('activityGroup').id
        const url = Router.path(
            'subscription_promotion_paywall',
            { context: 'activity_group' },
            { query: { activityGroupId } }
        )
        const segVar = `ut:aG/${activityGroupId}/layer/membership/required`

        upgradeService.track({ name: segVar })

        this.initSubview(PaywallView, {
            paywallType: 'group',
            modalOptions: { url },
            upgradeHandler: 'activity_group',
            upgradeHandlerParameters: { activityGroupId: dataProvider.get('activityGroup').id },
        }).render()
    },
})

export default new Ctrl()
